import { Button, Modal, Input, Form, Select, message, Col, Row, DatePicker, Table, List, Skeleton, Divider } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { requestError } from '../../controllers/functions';
import { MessageOutlined, PhoneOutlined } from '@ant-design/icons';

const SchoolBillingContactsModal = ({ show, setOpenModal, record, extractTokenFromUrl }) => {

  const [form] = Form.useForm();
  const [ contacts , setContacts ] = useState([]);
  const [ contact, setContact ] = useState({});
  const [ loading, setLoading ] = useState({})

  const saveContact = (v) => {
    const url = contact?.id ? process.env.REACT_APP_API_URI+`/schools/billing/contacts/${contact?.id}` : process.env.REACT_APP_API_URI+"/schools/billing/contacts"
    axios.post( url ,{ ...v, schoolId : record?.id }, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
        message.success(done.data.res);
        getContacts();
        form.resetFields();
        setContact({})
    }).catch( error => {
        requestError({error});
    })
  }

  const getContacts = React.useCallback(() => {
    setLoading( prev =>({ ...prev , logingContacts : true }))
    axios.get( process.env.REACT_APP_API_URI+`/schools/billing/contacts/${record?.id}`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
        setContacts(done.data);
        }).catch( error => {
            requestError({error});
        }).finally( done => {
            setLoading( prev =>({ ...prev , logingContacts : false }))
        })
  }, [record?.id, extractTokenFromUrl]);

  const deletedContact = React.useCallback((id) => {
    axios.delete( process.env.REACT_APP_API_URI+`/schools/billing/contacts/${id}`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
            message.success(done.data.res);
            getContacts();
        }).catch( error => {
            requestError({error});
        })
  }, [getContacts, extractTokenFromUrl]);

  useEffect(()=>{
    if(show) {
        getContacts()
    }
  }, [getContacts, show])

  return (
    <>
    
      <Modal 
      title={`${record?.name} Billing Contact Informations ` }
      open={show} 
      onOk={()=>setOpenModal(false)} 
      onCancel={()=>setOpenModal(false)}
      loading={loading.logingContacts}
      footer={[
        <Button key="cancel" type=""  onClick={()=>{setOpenModal(false)}}>
            Close
        </Button>    
      ]}
      >
      <List
        dataSource={contacts}
        loading={loading.logingContacts}
        renderItem={(item) => (
          <List.Item
            style={{ fontSize: 13 }}
          >
            <Skeleton avatar title={false} loading={item?.loading} active>
              <List.Item.Meta
                title={
                  <a href="#" style={{ fontSize: 12 }}>
                    {item?.name}
                  </a>
                }
                description={
                  <div style={{ color: "#888" }}>
                    <div style={{ fontSize: 12, display : "flex", gap : 10 }}>

                      <div>
                        <span style={{ fontWeight : 600 }}><PhoneOutlined/>{" "}</span>
                        <span><a href={`tel:${item.phone}`}>{item.phone}</a></span>
                      </div>

                      <div>
                        <span style={{ fontWeight : 600 }}>
                          <MessageOutlined/>
                          {" "}
                        </span>
                        <a href={`mailto:${item.email}`}>{item.email}</a>
                      </div>
                      
                    </div>

                    <div style={{ marginTop: "0.6rem" }}>
                      <Button
                        size="small"
                        type="link"
                        onClick={()=>{
                            form.setFieldsValue(item);
                            setContact(item);
                        }}
                      >
                        <span style={{ fontSize: 11 }}> Edit </span>
                      </Button>

                      <Button
                        size="small"
                        type="link"
                        onClick={() => {
                          Modal.confirm({
                            title: "Are you sure you want to delete this?",
                            onCancel: () => {},
                            onOk: () => deletedContact(item?.id),
                          });
                        }}
                        danger
                      >
                        <span style={{ fontSize: 11 }}>Delete</span>
                      </Button>
                    </div>
                  </div>
                }
              />
            </Skeleton>
          </List.Item>
        )}
      />

      <Divider/>

      <Form
      layout="vertical"
      className="row-col"
      onFinish={saveContact}
      id="school-billing-infor-form" 
      form={form}
      >
        <Row>

          <Col span={24} >
            <Form.Item
            name = "name" 
            style={{marginRight: 5}}
            rules={[
                { required: true, message: "Please input Name!" },
            ]}
            >
              <Input placeholder='Name' />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24}  md={12} lg={12} >
            <Form.Item
            name = "email" 
            style={{marginRight: 5}}
            rules={[
                { required: true, message: "Please input Email!" },
            ]}
            >
              <Input placeholder='Email' />
            </Form.Item>
          </Col>
            
            <Col xs={24} sm={24} md={12} lg={12}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Form.Item
                    name="phone"
                    style={{ flex: 1, marginRight: 5 }}
                    rules={[{ required: true, message: "Please input phone number!" }]}
                    >
                    <Input placeholder="Phone" type='number' />
                    </Form.Item>
                    <Form.Item >
                    <Button
                        type="primary"
                        htmlType="submit"
                        form="school-billing-infor-form"
                        style={{
                            height : 32
                        }}
                    >
                        +
                    </Button>
                    </Form.Item>
                </div>
            </Col>


        </Row>
        </Form>

      </Modal>
    </>
  );
};

export default SchoolBillingContactsModal;

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
  },
];

